import axios from "axios"
import * as settings from "../settings"

function RedrawMap(map) {
    if (map) {
        // Remove the tiles for a particular source
        map.style._sourceCaches['other:plan'].clearTiles()
        // Load the new tiles for the current viewport (map.transform -> viewport)
        map.style._sourceCaches['other:plan'].update(map.transform)

        map.style._sourceCaches['other:school-boundaries'].clearTiles()
        map.style._sourceCaches['other:school-boundaries'].update(map.transform)
        // Force a repaint, so that the map will be repainted without you having to touch the map
        // map.triggerRepaint()
    }
}

function ClearMapListeners(map) {
    if (map) {
        map._listeners.click = []
        map._listeners.mousedown = []
        map._listeners.mouseup = []
    }
}

function MakeSwap(map, plan, level, from_block, to_block) {
    axios.get(`${settings.API_SERVER}/api/update/make_swap/${plan}/${level}/${from_block}/${to_block}/`).then((res) => {
        RedrawMap(map)
    }).catch((e) => { console.log(e) })
}

export { RedrawMap, ClearMapListeners, MakeSwap }
